import { render, staticRenderFns } from "./SelectBaseComponent.vue?vue&type=template&id=32260d1b&"
import script from "./SelectBaseComponent.vue?vue&type=script&lang=js&"
export * from "./SelectBaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports